import React from 'react';
import ConditionalRenderer, { If } from '@components/ConditionalRenderer';
import Icon from '@components/Icon';
import './style.scss';

const ModalHeading = ({ title, icon, onBack }) => (
  <div className='modal-heading main-radius'>
    <div className='modal-heading__title modal__title title-xl tablet-title-xl mobile-title-xl'>
      <ConditionalRenderer condition={onBack}>
        <If>
          <div className='modal-heading__back' onClick={onBack}>
            <Icon type='arrow-left' />
          </div>
        </If>
      </ConditionalRenderer>
      {title}
    </div>
    <div className='modal-heading__icon'>
      <img src={icon} alt='' />
    </div>
  </div>
);

export default ModalHeading;
